var twoLib = require('two.js');
var $ = require('jquery');
var AnimationFrame = require('animation-frame');
var Colors = require('./colors.js');
var TWEEN = require('tween.js');

var _this = {};

var bgRect;
var bgGradient;
var shapeGradient;


var sprite;
var allSprites = [];
var custom;
var group;
var spriteGroup;
var scrollAmount = 0;
var scrollDamp = Math.max(0.6, 0.95 - ($(window).width()/2000));

var af = new AnimationFrame();
var opacity;
var scale;

//Graphics Settings
var oSize = 1000;
var numSprites = Math.max(35, Math.sqrt($(window).width()) * 4);
var lengthRange = {min: 100, max: 500};
var thickRange = {min: 25, max: 200};
var speedDamp = {min: 1, max: 1};

// Utility Functions
var getAngle = function() {
	var result = (Math.random() < 0.5) ? 135 : 45;
	return result * Math.PI / 180;
}

var getValueFromRange = function(range) {
	return ( Math.random()*(range.max-range.min) ) + range.min;
}

var getVerticesFromPosition = function(x, y, length, position, radians) {

	var x1, y1, x2, y2;

	if (position > .5) {
		position = 1 - position;
	}

    x1 = (length * position) * Math.cos(radians) + x;
    y1 = (length * position) * Math.sin(radians) + y;

    x2 = (length * position * -1) * Math.cos(radians) + x;
    y2 = (length * position * -1) * Math.sin(radians) + y;

	return {x1:x1, y1:y1, x2:x2, y2:y2}

}

var pushScrollDiff = function(amount, mod) {
    scrollAmount += amount / mod;
}

var doDiff;
var isSetup = false;

var animate = function() {
  two.update();
	af.request(animate);
	TWEEN.update();
}

var maxTweens = 6;
var numTweens = 0;
var capTweens;

_this.startPieces = function() {
 for (var i = 0; i < maxTweens; i++) {
 	_this.animatePiece();
 }
}

var tweenDuration;
var driftBase = 12;
var driftPad = 3;

_this.getDrift = function() {
	var rads = Math.floor(Math.random()*12)*30 * (Math.PI/180);
	var val = Math.ceil(Math.random()*driftBase) + driftPad;
	return {x: (val*Math.sin(rads)).toString(), y: (val*Math.cos(rads)).toString()};
}

_this.animatePiece = function() {

 	var piece = _this.getPiece();
  // console.log('returned piece', piece);
  if (!piece) {
    return;
  }

 	tweenDuration = Math.random()*1250 + 250;
 	tweenDelay = Math.random()*750 + 250;

 	var tween = new TWEEN.Tween(piece.translation)
 		.to(_this.getDrift(), tweenDuration)
 		.delay(tweenDelay)
 		.easing( TWEEN.Easing.Sinusoidal.InOut )
 		.onStart(function() {
 			// console.log('start', piece);
      numTweens++;
      // console.log('tweens', numTweens, capTweens);
 		})
 		.onComplete(function(){
      // console.log('finish', piece);
      if (numTweens < capTweens) {
   			_this.animatePiece();
      }
 		})
 		.start();
}

_this.getPiece = function() {

  // console.log('allSprites.length', allSprites.length);

  if (allSprites.length === 0) {
    return;
  }

	var piece = allSprites.splice(Math.floor(Math.random()*allSprites.length), 1)[0];
  // console.log('fetched piece', piece);
	return piece;

}

var colorSet = 1;//Math.ceil(Math.random()*4);

_this.setup = function() {
	
	
	if (!isSetup) {

		two = new Two({
			width: oSize,
			height: oSize,
			autostart: false
		}).appendTo($('#graphic-bg')[0]);

		group = new Two.Group();

		var colorId = Math.ceil(Math.random()*4);

		spriteGroup = two.interpret($('#base_pattern > svg')[0]);
		spriteGroup.fill = '#ffffff';
		spriteGroup.stroke = '#ffffff';
		spriteGroup.linewidth = 3.5;

    capTweens = Math.floor(spriteGroup.children.length / 4);
		group.add(spriteGroup);

	//Background
		// bgRect = new Two.Path([
		// 	new Two.Vector(0,0),
		// 	new Two.Vector(0, oSize),
		// 	new Two.Vector(oSize, oSize),
		// 	new Two.Vector(oSize,0),
		// ], true, false, false);

		// bgRect.fill = '#fff';
		// bgRect.opacity = 0.75;//bgGradient;
		// bgRect.noStroke();
		// group.add(bgRect);

		two.scene.add(group);

    console.log('spriteGroup', spriteGroup.children)

		for (var i = 0; i < spriteGroup.children.length; i++) {
      sprite = spriteGroup.children[i];
			allSprites[i] = sprite;
    }


    console.log('allSprites', allSprites)
	
	// $('#base_pattern').remove();
	$('#container').addClass('reveal');
	$('#graphic-bg').addClass('reveal');
	isSetup = true;

	_this.updateDimensions($(window).width(), $(window).height());
	two.update();
	animate();
	_this.startPieces();
	}

}


var xOff,
	yOff,
	wLast,
	hLast,  
	lSize,
	isWide
;

_this.updateDimensions = function(w, h) {

	if (w === wLast) {
		if (Math.abs(h - hLast) < 70) {
			console.log('skip update updateDimensions')
			return;
		}
	}

	lSize = Math.max(w,h);
	isWide = (w >= h) ? true : false;
	console.log('updateDimensions', w, h, isWide);

	if (isWide) {
		scale = w / oSize;
		yOff = 0 - (((scale * oSize) - h) / 2);
		console.log('yOff', yOff, scale);
		group.translation.set( 0, yOff );
	} else {
		scale = (h+100) / oSize;
		console.log('scale', scale);
		xOff = 0 - (((scale * oSize) - w) / 2);
		console.log('xOff tall', h, xOff, scale);
		group.translation.set( xOff, 0 );
	}

	console.log('scale', scale);
	group.scale = scale;

	// two.width = wLast = w;
	hLast = h;
	// two.height = h + 100;
	two.update();

}

var lastScroll = 0;
var nowScroll = 0;
var scrollDiff = 0;

var win = $(window);
var scrollTop;
var yDelta;

_this.scroll = function(e) {
	scrollTop = win.scrollTop();

	// for (var i = 0; i < allSprites.length; i++) {

 //    	sprite = allSprites[i];
 //    	if (sprite._custom.animate) {
	//     	yDelta = 0 - (sprite._custom.speed * scrollTop) % oSize;
	//     	sprite.translation.set(0, yDelta)
	//     }
 //  	}
}

// if (Modernizr.touch) {

//   $(window).on('touchmove', function(e) {

//     nowScroll = e.originalEvent.touches[0].clientY;
//     scrollDiff = (nowScroll - lastScroll);
//     pushScrollDiff(scrollDiff, 1500);
//     lastScroll = nowScroll;
//   })

// } else {



// $(window).on('scroll', function(e){
  
//   nowScroll = $(window).scrollTop();
//   scrollDiff = (nowScroll - lastScroll);
//   pushScrollDiff(scrollDiff, 1500);
//   lastScroll = nowScroll;

// });

  // }



module.exports = _this;


//////////////////
// WEBPACK FOOTER
// ./scripts/graphics2017.js
// module id = 1
// module chunks = 0